import React, { useEffect, useState } from "react";
import LineIcon from "./ModalComponent/LineIcon";
import useBookingPricing from "./hooks/useBookingPricing";
import BookingHeader from "./ModalComponent/BookingHeader";
import ConfirmationPage from "./ModalComponent/ConfirmationPage";
import DetailsPage from "./ModalComponent/DetailsPage";
import ReviewPage from "./ModalComponent/ReviewPage";

const BookingModal = ({
  isOpen,
  selectedRoom,
  searchDetails,
  guestForm,
  bookingLoading,
  offers = [],
  onClose,
  onGuestChange,
  onSubmit,
}) => {

  const [bookingStep, setBookingStep] = useState("details");
  const [createdBooking, setCreatedBooking] = useState(null);

  /* =========================================================
     LOCK BACKGROUND SCROLL
  ========================================================= */

  useEffect(() => {

    if (!isOpen) {
      return;
    }

    const previousOverflow =
      document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => {

      document.body.style.overflow =
        previousOverflow;

    };

  }, [isOpen]);


  /* =========================================================
     SCROLL BOOKING CONTENT TO TOP
  ========================================================= */

  useEffect(() => {

    if (
      isOpen &&
      selectedRoom
    ) {

      window.scrollTo({
        top: 0,
        behavior: "instant",
      });

    }

  }, [
    isOpen,
    selectedRoom,
  ]);


  /* =========================================================
     SAFETY
  ========================================================= */

  if (
    !isOpen ||
    !selectedRoom
  ) {
    return null;
  }

  const bookingDetails = searchDetails || {
    checkIn: "",
    checkOut: "",
    adults: 1,
    children: 0,
  };
  const {
    roomPrice,
    calculatedNights,
    roomTotal,
    taxRate,
    taxAmount,
    finalTotal,
  } = useBookingPricing(
    selectedRoom,
    bookingDetails
  );

  const adults =
    Number(
      bookingDetails.adults || 1
    );

  const children =
    Number(
      bookingDetails.children || 0
    );
  const totalGuests =
    adults + children;

  const handleRequestToBook = (e) => {

    e.preventDefault();

    if (!guestForm.name?.trim()) {
      alert("Please enter your name.");
      return;
    }

    if (!guestForm.mobile?.trim()) {
      alert("Please enter your mobile number.");
      return;
    }

    if (!guestForm.email?.trim()) {
      alert("Please enter your email.");
      return;
    }

    if (!searchDetails?.checkIn ||
      !searchDetails?.checkOut) {
      alert(
        "Please select your check-in and check-out dates."
      );
      return;
    }

    setBookingStep("review");

    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  };

  return (
    <div
      className="be-booking-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Complete your booking"
    >
      <div className="be-booking-modal-page">

        <BookingHeader
          bookingStep={bookingStep}
          onClose={onClose}
        />
        {/* =====================================================
            MAIN
        ===================================================== */}

        <main className="be-booking-page-main">


          {/* TITLE */}
          {bookingStep === "review" ? (

            <ReviewPage
              selectedRoom={selectedRoom}
              bookingDetails={bookingDetails}
              guestForm={guestForm}

              adults={adults}
              children={children}
              offers={offers}
              roomPrice={roomPrice}
              calculatedNights={calculatedNights}
              roomTotal={roomTotal}
              taxRate={taxRate}
              taxAmount={taxAmount}
              finalTotal={finalTotal}
              bookingLoading={bookingLoading}
              setBookingStep={setBookingStep}
              setCreatedBooking={setCreatedBooking}
              onSubmit={onSubmit}
            />

          ) : bookingStep === "confirmation" ? (
            <ConfirmationPage
              guestForm={guestForm}
              bookingDetails={bookingDetails}
              selectedRoom={selectedRoom}
              finalTotal={finalTotal}
              createdBooking={createdBooking}
              adults={adults}
              children={children}
              onClose={onClose}
            />
          ) : (
            <DetailsPage
              selectedRoom={selectedRoom}
              bookingDetails={bookingDetails}
              searchDetails={searchDetails}
              guestForm={guestForm}
              onGuestChange={onGuestChange}
              adults={adults}
              children={children}
              totalGuests={totalGuests}
              roomPrice={roomPrice}
              calculatedNights={calculatedNights}
              roomTotal={roomTotal}
              taxRate={taxRate}
              taxAmount={taxAmount}
              finalTotal={finalTotal}
              bookingLoading={bookingLoading}
              setBookingStep={setBookingStep}
            />
          )}
        </main>
      </div>
    </div>
  );
};
export default BookingModal;